import { Component, Input, OnInit } from '@angular/core'
import * as moment from 'moment'
import { Constants } from '../../../../api/constants/constants'
import { TimeCard } from '../../../../api/models/timecard.model'
import { Timesheet } from '../../../../api/models/timesheet.model'
import { Utils } from '../../../common/utils/utils'
import { TimeCardRep } from '../model/timecard-rep.model'
import { TimesheetDayRep } from '../model/timesheet-day-rep.model'
import { TimesheetContainer } from '../timesheets.component'

@Component({
    selector: 'ppw-timesheets-detail',
    templateUrl: './timesheets-detail.component.html',
    styleUrls: ['./timesheets-detail.component.scss']
})
export class TimesheetsDetailComponent implements OnInit {
    @Input() timesheet!: TimesheetContainer
    @Input() isViewByTag!: boolean
    error: boolean
    daysInMonth?: Array<TimesheetDayRep>
    pageTitle = 'Timesheets'
    dayHoursToInvoice!: string
    dayHoursNoInvoice!: string
    isProdEnv!: boolean

    trackBy = Utils.trackByIndex
    private readonly constants = Constants.getConstantsSingleton()

    constructor() {
        this.error = false
    }

    ngOnInit(): void {
        this.setDaysInMonth()
        this.dayHoursToInvoice = Utils.secondsAsWholeWorkingDaysAndHours(this.timesheet.secondsToInvoice)
        this.dayHoursNoInvoice = Utils.secondsAsWholeWorkingDaysAndHours(this.timesheet.secondsNoInvoice)
        this.isProdEnv = this.constants.ENVIRONMENT === 'PROD'
    }

    private setDaysInMonth(): void {
        const timesheetMoment = moment()
        timesheetMoment.set('year', this.timesheet.year)
        timesheetMoment.set('month', moment().month(this.timesheet.month).month())

        const numberOfDaysInMonth = timesheetMoment.daysInMonth()
        const daysInMonth = new Array<TimesheetDayRep>()

        for (let i = 1; i <= numberOfDaysInMonth; i++) {
            const day = moment(timesheetMoment)
            day.set('date', i)
            const timesheetDayRep: TimesheetDayRep = {
                moment: day,
                detailed: this.timesheet.detailed,
                showPriority: this.timesheet.timesheetProject.showPriority,
                timeCardReps: this.getTimeCardsForTimesheetDayRep(day.date(), this.timesheet)
            }
            daysInMonth.push(timesheetDayRep)
        }
        this.daysInMonth = daysInMonth
    }

    private getTimeCardsForTimesheetDayRep(date: number, timesheet: Timesheet): Array<TimeCardRep> {
        const result = new Array<TimeCardRep>()
        if (timesheet && timesheet.timeCards) {
            timesheet.timeCards.forEach((timeCard: TimeCard) => {
                if (timeCard.date.getDate() === date) {
                    result.push(
                        new TimeCardRep(
                            timeCard,
                            timesheet.detailed,
                            timesheet.timesheetProject.showPriority,
                            this.isViewByTag
                        )
                    )
                }
            })
        }

        return result
    }
}
